import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isResponseValidationError } from 'up-fetch';

import { HttpClientError, HttpMaintenanceError, HttpUnauthenticatedError } from '~/api/errors';
import { sessionEnded } from '~/api/session';
import { maintenanceStore } from '~/hooks/useMaintenanceMode.store';

import { env } from '../../constants/env';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // eslint-disable-next-line no-console
      if (!env.IS_PRODUCTION_ENV) console.error(`Query ${query.queryHash} threw the following error:\n\n`, error);

      if (error instanceof HttpMaintenanceError) maintenanceStore.setMaintenance(true);
      if (error instanceof HttpUnauthenticatedError) sessionEnded.notify();
    },
    onSuccess: () => {
      maintenanceStore.setMaintenance(false);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      // eslint-disable-next-line no-console
      if (!env.IS_PRODUCTION_ENV) console.error('A mutation threw the following error:\n\n', error);

      if (error instanceof HttpMaintenanceError) maintenanceStore.setMaintenance(true);
      if (error instanceof HttpUnauthenticatedError) sessionEnded.notify();
    },
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof HttpClientError || error instanceof HttpMaintenanceError || isResponseValidationError(error)) {
          return false;
        }

        return failureCount < 2; // = 3 tries
      },
    },
  },
});

// Broadcast Channel for query syncing between browser contexts
broadcastQueryClient({
  queryClient,
  broadcastChannel: 'craft',
});
